import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2093edb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile__phone flex align-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "profile__phone__icon",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.76085 1.66187C2.8315 1.59123 2.86682 1.5559 2.89794 1.52731C3.6631 0.82423 4.83921 0.82423 5.60436 1.52731C5.63548 1.5559 5.67081 1.59123 5.74145 1.66187L7.19965 3.12007C8.0017 3.92212 8.23109 5.13336 7.77785 6.17314C7.32461 7.21293 7.554 8.42416 8.35605 9.22622L10.7529 11.623C11.5549 12.4251 12.7661 12.6545 13.8059 12.2012C14.8457 11.748 16.057 11.9774 16.859 12.7794L18.3172 14.2376C18.3878 14.3083 18.4232 14.3436 18.4518 14.3747C19.1548 15.1399 19.1548 16.316 18.4518 17.0811C18.4232 17.1123 18.3878 17.1476 18.3172 17.2182L17.4309 18.1046C16.7091 18.8264 15.6685 19.1294 14.6721 18.9079C7.88248 17.3991 2.57995 12.0966 1.07115 5.307C0.849715 4.31054 1.15272 3.27001 1.87451 2.54821L2.76085 1.66187Z",
    stroke: "black",
    "stroke-width": "1.5"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10 7L11.763 8.74731C13.1689 10.1408 13.8719 10.8375 13.9801 11.6867C14.0066 11.8947 14.0066 12.1053 13.9801 12.3133C13.8719 13.1625 13.1689 13.8592 11.763 15.2527L10 17",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_4 = {
  key: 1,
  class: "desktopMenu"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SettingsLink = _resolveComponent("SettingsLink")!
  const _component_SettingsItemArrow = _resolveComponent("SettingsItemArrow")!
  const _component_SettingsItem = _resolveComponent("SettingsItem")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["profile--wrap", { desktop: _ctx.isDesktop }])
  }, [
    (!_ctx.isPublic())
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["profile flex align-center", { 'row-reverse': _ctx.isDesktop, settings: _ctx.isSettings }])
        }, [
          _createVNode(_component_UserAvatar, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickAvatar'))),
            class: _normalizeClass(["profile__avatar", { isDesktop: _ctx.isDesktop }])
          }, null, 8, ["class"]),
          _createElementVNode("div", {
            class: _normalizeClass({ 'flex direction-column align-center': _ctx.isSettings })
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(["profile__name", { isDesktop: _ctx.isDesktop }])
            }, _toDisplayString(_ctx.user.name || "Empty"), 3),
            _createElementVNode("p", _hoisted_1, [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.user.phone), 1)
            ])
          ], 2),
          (_ctx.type === 'menu')
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                class: "profile__link flex flexCenter",
                to: _ctx.ROUTES.USER_SETTINGS.path
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_SettingsLink, {
            "with-out-border": true,
            to: _ctx.ROUTES.USER_SETTINGS.path,
            icon: "settings.svg",
            text: "profile.settings",
            class: "desktopMenu__settingsLink"
          }, null, 8, ["to"]),
          _createVNode(_component_SettingsItem, {
            onClick: _ctx.onLogOut,
            "with-out-border": true,
            text: "profile.logOut",
            icon: "logOut.svg",
            class: "desktopMenu__logOutLink pointer"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SettingsItemArrow)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 2)), [
    [_directive_click_outside, () => _ctx.$emit('update:isOpen', false), 300]
  ])
}